import React from "react";
import { useContent } from "../context/ContentContext";

export default function Sustainability() {
  const { content } = useContent();
  const s = content.sustainability || {};
  const items = s.items || [];
  return (
    <div className="container py-4">
      <h1 className="mb-4 text-success">{s.title || "Sustainability"}</h1>
      <ul>
        {items.map((item, i) => (
          <li key={i}>
            <strong className="text-warning">{item.title}</strong> {item.text}
          </li>
        ))}
      </ul>
    </div>
  );
}
